import { cloneDeep } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const getUpdatedOrder = (currentOrder, moveFromIndex, moveToIndex) => {
  const newOrder = cloneDeep(currentOrder);
  const currentToOrder = currentOrder[moveToIndex].order;

  // first pass - just update order from 'from index' to 'to index'
  let i = moveToIndex;
  while (i !== moveFromIndex) {
    if (moveFromIndex > moveToIndex) {
      newOrder[i].isOrderChanged = true;
      newOrder[i].order = currentOrder[i + 1].order;

      i += 1;
    } else {
      newOrder[i].isOrderChanged = true;
      newOrder[i].order = currentOrder[i - 1].order;

      i -= 1;
    }
  }

  newOrder[moveFromIndex].order = currentToOrder;
  newOrder[moveFromIndex].isOrderChanged = true;

  // move 'from' item to 'to' pos
  const fromItem = newOrder[moveFromIndex];
  newOrder.splice(moveFromIndex, 1);
  newOrder.splice(moveToIndex, 0, fromItem);

  // second pass - check for duplicate orders (fix legacy issue)
  newOrder.forEach((newOrderItem, index) => {
    if (index > 0 && newOrderItem.order <= newOrder[index - 1].order) {
      newOrder[index].isOrderChanged = true;
      newOrder[index].order = newOrder[index - 1].order + 1;
    }
  });

  return newOrder;
};
